import {nullableDateTimeStringFromApiToDate} from "../../../index";
import {AsyncListInput} from "../../../core/sharedmodels/asyncList/asyncListInput";
import {LaegekursusGruppeTypeEnum} from "../../../core/sharedmodels/kursus/laegekursusGruppeTypeEnum";
import { UddannelseTypeEnum } from "core/sharedmodels/stilling/uddannelseTypeEnum";
import { KursusTypeEnum } from "core/sharedmodels/kursus/kursusTypeEnum";
import { LaegekursusStatusEnum } from "core/sharedmodels/kursus/laegekursusStatusEnum";
import { KursusoverviewBrugerKursusRaekkeResponseModel, KursusoverviewLaegeKursusResponseModel } from "services/api/laegekursus/kursusOverviewBrugerKursusRaekkeResponseModel";
import { ReactTableBaseData } from "core/components/reactTable/types";

export class KursusoverviewModel implements ReactTableBaseData {
    public static FromResponseModel(responseModel: KursusoverviewBrugerKursusRaekkeResponseModel) {
        const model = new KursusoverviewModel();
        model.isParentRow = true;
        model.isPlaceholder = false;

        model.brugerKursusRaekkeId = responseModel.brugerKursusRaekkeId;
        model.brugerId = responseModel.brugerId;
        model.brugerNavn = responseModel.brugerNavn;
        model.brugerInitialer = responseModel.brugerInitialer;
        model.brugerAuthId = responseModel.brugerAuthId;
        model.brugerEmail = responseModel.brugerEmail;
        model.uddannelseType = responseModel.uddannelseType;
        model.specialeId = responseModel.specialeId;
        model.specialeNavn = responseModel.specialeNavn;
        model.slutDatoForSidsteAktiveDelForloeb = nullableDateTimeStringFromApiToDate(responseModel.slutDatoForSidsteAktiveDelForloeb);
        model.regions = responseModel.regions;
        const responseModelBase = {
            ...responseModel,
            laegeKurser: []
        } as KursusoverviewBrugerKursusRaekkeResponseModel;

        model.laegeKurser = responseModel.laegeKurser.length > 0 
            ? responseModel.laegeKurser.map(laegeKursus => KursusoverviewModel.FromLaegeKursusResponseModel(responseModelBase, laegeKursus))
            : [];

        return model;
    }

    private static FromLaegeKursusResponseModel(bkrResponseModelBase: KursusoverviewBrugerKursusRaekkeResponseModel, lkResponseModel: KursusoverviewLaegeKursusResponseModel) {
        const model = this.FromResponseModel(bkrResponseModelBase); //Base model

        model.isParentRow = false;
        model.isPlaceholder = false;
        model.laegeKursusId = lkResponseModel.laegeKursusId;
        model.kursusId = lkResponseModel.kursusId;
        model.kursusTitel = lkResponseModel.titel;
        model.kursusGruppe = lkResponseModel.kursusGruppe;
        model.kursusType = lkResponseModel.kursusType;
        model.kursusStartDato = nullableDateTimeStringFromApiToDate(lkResponseModel.startDato);
        model.kursusSlutDato = nullableDateTimeStringFromApiToDate(lkResponseModel.slutDato);
        model.kursusGodkendtDato = nullableDateTimeStringFromApiToDate(lkResponseModel.godkendtDato);
        model.kursusStatus = lkResponseModel.status;

        model.laegeKurser = undefined; //No laegeKurser on laegeKursus.

        return model;
    }

    /** 
     * For creating placeholer row (which is not shown in table). 
     * Used for still making aggregation work (even though there is zero subRows) 
     * */
    public static AsPlaceholder(parent: KursusoverviewModel) {
        const model = new KursusoverviewModel();
        model.isParentRow = false;
        model.isPlaceholder = true;

        model.brugerKursusRaekkeId = parent.brugerKursusRaekkeId;
        model.brugerId = parent.brugerId;
        model.brugerNavn = parent.brugerNavn;
        model.brugerAuthId = parent.brugerAuthId;
        model.brugerEmail = parent.brugerEmail;
        model.uddannelseType = parent.uddannelseType;
        model.specialeId = parent.specialeId;
        model.specialeNavn = parent.specialeNavn;
        model.slutDatoForSidsteAktiveDelForloeb = parent.slutDatoForSidsteAktiveDelForloeb;
        model.laegeKurser = undefined;
        
        return model;
    }

    isParentRow: boolean;
    isPlaceholder: boolean;

    brugerKursusRaekkeId: string;
    brugerId: string;
    brugerNavn: string;
    brugerInitialer: string;
    brugerAuthId?: string;
    brugerEmail: string;
    uddannelseType: UddannelseTypeEnum;
    specialeId: string;
    specialeNavn: string;
    slutDatoForSidsteAktiveDelForloeb?: Date;
    regions: string[];

    laegeKursusId?: string;
    kursusId?: string;
    kursusTitel?: string;
    kursusGruppe?: LaegekursusGruppeTypeEnum;
    kursusType?: KursusTypeEnum;
    kursusStartDato?: Date;
    kursusSlutDato?: Date;
    kursusGodkendtDato?: Date;
    kursusStatus?: LaegekursusStatusEnum;

    laegeKurser?: KursusoverviewModel[]; // children
}

export type KursusoverviewFilterModel = {
    regionIds?: string[];
    uddannelseIds?: string[];
    specialeIds?: string[];
    kursusgrupper?: LaegekursusGruppeTypeEnum[];
}

export type KursusoverviewFilterAsyncListInput = {
    kursusoverviewFilter: KursusoverviewFilterModel;
    //Possible to add more filters for table here.
} & AsyncListInput;

